import { Route } from '@angular/router';

import { DOMAIN_ROUTES } from 'libs/shared/utils/constants/routes.constant';

export const appRoutes: Route[] = [
  {
    path: DOMAIN_ROUTES.TEMPLATE_PREVIEW,
    loadChildren: () =>
      import('@offconon/domain/page/template-preview').then((m) => m.templatePreviewRoutes),
  },
  {
    path: ':lang/' + DOMAIN_ROUTES.TEMPLATE_PREVIEW,
    loadChildren: () =>
      import('@offconon/domain/page/template-preview').then((m) => m.templatePreviewRoutes),
  },
  {
    path: DOMAIN_ROUTES.UNDER_CONSTRUCTION,
    loadChildren: () =>
      import('@offconon/domain/page/under-construction').then((m) => m.underConstructionRoutes),
  },
  {
    path: ':lang/' + DOMAIN_ROUTES.UNDER_CONSTRUCTION,
    loadChildren: () =>
      import('@offconon/domain/page/under-construction').then((m) => m.underConstructionRoutes),
  },

  {
    path: ':lang',
    loadChildren: () =>
      import('@offconon/domain/feature/domain-shell').then((m) => m.domainShellModuleRoutes),
  },
  {
    path: ':lang/:page',
    loadChildren: () =>
      import('@offconon/domain/feature/domain-shell').then((m) => m.domainShellModuleRoutes),
  },
  {
    path: ':lang/:page/:slug',
    loadChildren: () =>
      import('@offconon/domain/feature/domain-shell').then((m) => m.domainShellModuleRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@offconon/domain/feature/domain-shell').then((m) => m.domainShellModuleRoutes),
  },
  {
    path: DOMAIN_ROUTES.NOT_FOUND,
    redirectTo: DOMAIN_ROUTES.UNDER_CONSTRUCTION,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
